<button
  color="primary"
  mat-button
  (click)="handleClick()"
  [disabled]="disabled"
  [ngClass]="getButtonClasses()"
  [class.align-button-wrapper]="addAlignButtonWrapperClass"
>
  <mat-spinner *ngIf="loading" [diameter]="25" [strokeWidth]="2"></mat-spinner>
  <p *ngIf="!loading">{{ text }}</p>
  <app-opin-icon [icon]="icon" *ngIf="icon" [color]="colorIcon"></app-opin-icon>
</button>
